import { cn } from '@app/utils/cn';

import { Skeleton } from '../Skeleton';

interface AttributeProps {
  className?: string;
  name: string | JSX.Element;
  value: React.ReactNode | React.ReactNode[];
  isLoading?: boolean;
  dataTestId?: string;
  orientation?: 'vertical' | 'horizontal';
}

export const Attribute = ({ name, value, isLoading, className, dataTestId, orientation = 'horizontal' }: AttributeProps) => (
  <div data-testid={dataTestId} className={cn('body-1', { 'flex flex-col gap-1': orientation === 'vertical' }, className)}>
    <dt className="contents">
      <span className="whitespace-pre text-neutral-40">{name}:</span>
    </dt>
    <dd className="contents" data-sentry-mask>
      {isLoading ?
        <Skeleton type="text" width={100} />
      : value}
    </dd>
  </div>
);
